import { combineReducers } from 'redux'

import { questProfile } from './quest'
import { questListProfile } from './questList'

export const questReducer = combineReducers({
  questProfile,
  questListProfile
})
